<div class="floating-label">
    <input bsDatepicker type="text" [bsConfig]="{isAnimated: true, dateInputFormat: 'MM/DD/YYYY'  }" placeholder="MM/DD/YYYY" [formControlName]="controlName" [id]="inputId" [class]="inputClass" [attr.placeholder]="placeholderText | translate" [readOnly]="readonly" [ngClass]="{ 'no-icon': !showIcon }" autocomplete="off" />
    <label-extended-control [labelText]="labelText"></label-extended-control>
    <div *ngIf="showIcon" class="icon">
        <span [class]="iconClass"></span>
    </div>
    <field-error-display-control [displayError]="parentFormHelper.showFieldError(controlName)" [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)"> </field-error-display-control>
</div>
